import {
    CREATE_EMPLOYEE_REQUEST,
    CREATE_EMPLOYEE_SUCCESS,
    CREATE_EMPLOYEE_FAILURE,
    DELETE_EMPLOYEE_REQUEST,
    DELETE_EMPLOYEE_SUCCESS,
    DELETE_EMPLOYEE_FAILURE,
    FETCH_SINGLE_EMPLOYEE_REQUEST,
    FETCH_SINGLE_EMPLOYEE_SUCCESS,
    FETCH_SINGLE_EMPLOYEE_FAILURE,
    FETCH_EMPLOYEE_REQUEST,
    FETCH_EMPLOYEE_SUCCESS,
    FETCH_EMPLOYEE_FAILURE,
    UPDATE_EMPLOYEE_REQUEST,
    UPDATE_EMPLOYEE_SUCCESS,
    UPDATE_EMPLOYEE_FAILURE,
    RESET_EMPLOYEE_INFO,
    CREATE_EMPLOYEE_FORM,
    UPDATE_EMPLOYEE_FORM
} from './employee.actionsType';

export const EMPLOYEE = 'employeeTable';

let initialState = {
    loading: false,
    employeeList: [],
    employeeform: {},
    selectedState: {},
    errorMessage: ''
};

export let employeeReducer = (state = initialState, action) => {
    let { type, updatePayload, payload } = action;

    switch (type) {
        case FETCH_EMPLOYEE_REQUEST:
        case CREATE_EMPLOYEE_REQUEST:
        case UPDATE_EMPLOYEE_REQUEST:
        case FETCH_SINGLE_EMPLOYEE_REQUEST:
        case DELETE_EMPLOYEE_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_EMPLOYEE_SUCCESS:
            return {
                ...state,
                loading: false,
                employeeList: updatePayload
            };
        case CREATE_EMPLOYEE_SUCCESS:
            return {
                ...state,
                loading: false,
                employeeform: {}
            };
        case UPDATE_EMPLOYEE_SUCCESS:
            return {
                ...state,
                loading: false,
                employeeform: {}
            };
        case FETCH_SINGLE_EMPLOYEE_SUCCESS:
            return {
                ...state,
                loading: false,
                employeeform: updatePayload
            };
        case DELETE_EMPLOYEE_SUCCESS:
            return {
                ...state,
                loading: false,
                employeeform: {}
            };
        case RESET_EMPLOYEE_INFO:
            return {
                ...state,
                employeeform: {}
            };
        case CREATE_EMPLOYEE_FORM:
        case UPDATE_EMPLOYEE_FORM:
            return {
                ...state,
                loading: false,
                employeeform: {
                    ...state.employeeform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_EMPLOYEE_FAILURE:
        case CREATE_EMPLOYEE_FAILURE:
        case UPDATE_EMPLOYEE_FAILURE:
        case FETCH_SINGLE_EMPLOYEE_FAILURE:
        case DELETE_EMPLOYEE_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
